import {
    SET_DASHBOARD_DATA,
    SET_DASHBOARD_PENDING
} from "./actionTypes";

const initialState = {
    isDashboardDataPending: false,
    dashboardData: []
};

export default (localState = initialState, action) => {
    switch (action.type) {
        case SET_DASHBOARD_PENDING: {
            return {
                ...localState,
                isDashboardDataPending: true,
            };
        }
        case SET_DASHBOARD_DATA: {
            const { dashboardData } = action.payload;
            return {
                ...localState,
                isDashboardDataPending: false,
                dashboardData: dashboardData,
            };
        }
        default: {
            return localState;
        }
    }
};
